<template>
    <div class="mx-auto w-full max-w-screen-2xl pt-8 pb-40 px-8">
        <div class="flex space-x-8" v-if="inspectionTestPlan">
            <div class="flex-1">
                <div
                    class="text-2xl font-bold text-gray-900 border-transparent rounded shadow-none px-2 py-1 -ml-2.5 mb-0">
                    Inspection Test Plan
                </div>

                <div class="text-sm text-gray-500">
                    Reference {{ inspectionTestPlan.package_reference }} - {{ inspectionTestPlan.reference }}
                </div>

                <div class="sticky top-0 bg-white -mx-2 px-2 mb-8 z-30">
                    <inspection-test-plan-tabs
                        class="mt-8"
                        :inspection-test-plan="inspectionTestPlan"
                        :active-section-index.sync="activeSectionIndex"
                        :active-page.sync="activePage"
                    ></inspection-test-plan-tabs>

                    <!-- IPT section header (if applicable). -->
                    <div v-if="activeSectionIndex !== null"
                         class="flex mt-8 border-t border-b border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold">
                        <div class="w-6 flex-shrink-0"></div>
                        <div class="w-16 border-l border-r border-gray-200 px-2 py-1">Ref</div>
                        <div class="flex-1 border-r border-gray-200 px-2 py-1">Description</div>
                        <div class="w-20 -ml-px border-r border-gray-200 px-2 py-1">Quantity</div>
                        <div class="w-20 -ml-px border-r border-gray-200 px-2 py-1">Unit</div>
                        <div class="w-40 -ml-px border-r border-gray-200 px-2 py-1">Test Method</div>
                        <div class="w-40 -ml-px border-r border-gray-200 px-2 py-1">Minimum Frequency</div>
                        <div class="w-6 flex-shrink-0 ml-2"></div>
                    </div>
                </div>
                <ui-form-section v-if="isPage('properties')">
                    <ui-input label="Principle Contrator" name="principleContractor"
                              v-model="inspectionTestPlan.principleContractor"
                              placeholder="Principle Contractor..."
                              class="xl:col-span-6"
                              @input="update"
                    ></ui-input>
                    <ui-input label="Contract Reference" name="contractReference"
                              v-model="inspectionTestPlan.contractReference"
                              placeholder="Contract Reference..."
                              class="xl:col-span-6"
                              @input="update"
                    ></ui-input>
                    <ui-textarea autoresize label="Site Address" name="siteAddress"
                                 v-model="inspectionTestPlan.siteAddress"
                                 class="col-span-12"
                                 @input="update"
                    ></ui-textarea>
                    <ui-textarea autoresize label="Location of Works" name="locationOfWorks"
                                 v-model="inspectionTestPlan.locationOfWorks"
                                 class="col-span-12"
                                 @input="update"
                    ></ui-textarea>
                </ui-form-section>
                <inspection-test-plan-section v-else :editable="true" :inspection-test-plan="inspectionTestPlan"
                                              :section="inspectionTestPlan.sections[activeSectionIndex]"
                                              :sectionIndex="activeSectionIndex" :update="update"></inspection-test-plan-section>

            </div>
            <div class="w-72 space-y-8 relative">
                <div class="w-72 space-y-1 fixed">
                    <inspection-test-plan-action-panel
                        :inspection-test-plan="inspectionTestPlan"></inspection-test-plan-action-panel>
                    <div
                        style="overflow-y: auto; padding-right:12px; margin-top:12px; padding-top:12px; top:0px; height:calc(100vh - 250px)">
                        <inspection-test-plan-status-panel
                            :inspection-test-plan="inspectionTestPlan"></inspection-test-plan-status-panel>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex space-x-8" v-else>
            Loading Inspection Test plan....
        </div>
    </div>

</template>

<script>
import {InspectionTestPlan} from "@models";
import InspectionTestPlanActionPanel from "./InspectionTestPlanActionPanel.vue";
import InspectionTestPlanStatusPanel from "./InspectionTestPlanStatusPanel.vue";
import InspectionTestPlanSection from "./InspectionTestPlanSection.vue";
import {clone, cloneDeep} from "lodash";

export default {
    components: {
        InspectionTestPlanSection,
        InspectionTestPlanStatusPanel, InspectionTestPlanActionPanel
    },
    props: {
        item: Object,
        packageReference: String,
    },
    data() {
        return {
            inspectionTestPlanModel: null,
            inspectionTestPlan: null,
            activeSectionIndex: null,
            activePage: 'properties',
        }
    },
    computed: {},
    methods: {
        isPage(page) {
            return this.activeSectionIndex === null && this.activePage === page
        },
        update() {
            Object.assign(this.inspectionTestPlanModel,this.inspectionTestPlan);
            this.inspectionTestPlanModel.update();
        }
    },
    async mounted() {
        this.inspectionTestPlan = await InspectionTestPlan.find(this.packageReference, this.item.id);
        this.inspectionTestPlanModel = cloneDeep(this.inspectionTestPlan);
    },
}
</script>
